import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient instance for managing data fetching and caching.
 * Configured with default settings for stale time, retries, and window focus behavior.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      refetchOnWindowFocus: false,
      retry: (failureCount, error: any) => {
        // Log retry attempt
        console.log("Query retry attempt:", {
          failureCount,
          error,
          status: error?.status,
          message: error?.message,
        });

        // Don't retry on 401 Unauthorized
        if (error?.status === 401 || error?.unauthorized) {
          console.warn("Not retrying 401 Unauthorized error");
          return false;
        }

        // Don't retry on 404 Not Found
        if (error?.status === 404) {
          console.warn("Not retrying 404 Not Found error");
          return false;
        }

        // Don't retry on validation errors
        if (error?.validationError) {
          console.warn("Not retrying validation error");
          return false;
        }

        // Retry other errors up to 3 times
        const shouldRetry = failureCount < 3;
        console.log("Should retry:", shouldRetry);
        return shouldRetry;
      },
      retryDelay: (attemptIndex) => {
        const delay = Math.min(1000 * 2 ** attemptIndex, 30000);
        console.log("Retry delay:", delay);
        return delay;
      }, // Exponential backoff
    },
  },
});
